import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Modal, Button, Row } from 'react-bootstrap';
import _ from 'lodash';
import ApiUtil from '../utils/api';

const ConfirmModal = observer(
  class ConfirmModal extends Component {
    constructor(props) {
      super(props);

      this.state = {
        data: {},
        endpoint: null,
        endpointType: 'GET',
        endpointData: undefined,
        endpointRawBody: false,
        showModal: false,
        disabled: false,
        isContentLoading: false,
        isConfirmLoading: false,
        classButton: 'btn-success',
        classConfirmButton: 'btn-success',
        showIcon: false,
        showButton: true,
        textButton: 'Open modal',
        textConfirmButton: 'Confirm',
        textCancelButton: 'Close',
        textTitle: 'Are you sure?',
        textContent: 'Are you sure you want to continue?',
        textContentTemporary: '',
        functionConfirm: null,
        functionConfirmCatch: null,
      };

      const newStateProps = _.pick(props, _.keys(this.state));
      _.assign(this.state, newStateProps);
    }

    async componentWillReceiveProps(props) {
      const newStateProps = _.pick(props, _.keys(this.state));
      this.setState(newStateProps);
    }

    /**
     * Closes the modal.
     */
    close = () => {
      this.setState({ showModal: false, textContent: this.state.textContentTemporary });
    };

    /**
     * Opens the modal, and does whatever connection needed to the backend.
     * Also updates the content of the modal to reflect the backend's response.
     *
     * @param {Object} event - event triggered
     */
    open = async event => {
      event.stopPropagation();
      const textContentTemporary = await _.clone(this.state.textContent);
      await this.setState({ isContentLoading: true, textContentTemporary });

      if (this.state.endpoint) {
        // Temporarly lock the button
        const textButton = this.state.textButton;
        await this.setState({
          disabled: true,
          textButton: <i className="fa fa-spinner fa-pulse" />,
        });

        await ApiUtil.billingAPI({
          requestType: this.state.endpointType,
          query: this.state.endpoint,
          data: this.state.endpointData,
          rawBody: this.state.endpointRawBody,
        })
          .then(response => {
            const textContent =
              response.length > 0
                ? response.map(this.renderContent)
                : 'This change will not alter any historical bills, bill approval reports or other data.';

            this.setState({ showModal: true, textContent, disabled: false, textButton });
          })
          .catch(response => {
            if (this.state.functionConfirmCatch) {
              this.close();
              return this.state.functionConfirmCatch(response);
            }
            this.setState({
              showModal: true,
              textContent: 'Something went wrong! Please close the modal and try again. ',
              disabled: false,
              textButton,
            });
          });
      } else {
        this.setState({ showModal: true });
      }

      await this.setState({ isContentLoading: false });
    };

    /**
     * Turns the loading icon on, disables the button .
     * Calls the confirm function passed through the props, then turns off loading icon and closes modal.
     */
    functionConfirm = async () => {
      this.setState({ isConfirmLoading: true });

      // If function doesn't exist
      if (!this.state.functionConfirm) {
        this.setState({ isConfirmLoading: false });
        this.close();
        return;
      }

      await this.state
        .functionConfirm(this.state.data)
        .then(async () => {
          await this.setState({ isConfirmLoading: false });
          this.close();
        })
        .catch(async () => {
          await this.setState({
            textContent: 'Something went wrong! Please close the modal and try again. ',
            isConfirmLoading: false,
          });
        });
    };

    /**
     * Renders the content for the modal.
     */
    renderContent = (item, index) => (
      <div key={index}>
        {item.title}
        <ul>
          {item.content.map((content, contentIndex) => <li key={contentIndex}>{content}</li>)}
        </ul>
        <br />
      </div>
    );

    render() {
      return (
        <span>
          <Modal show={this.state.showModal} onHide={this.close} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title>{this.state.textTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.isContentLoading ? (
                <Row className="text-center">
                  <i className="fa fa-spinner fa-pulse fa-3x" />
                </Row>
              ) : (
                <span>{this.state.textContent}</span>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.close}>{this.state.textCancelButton}</Button>
              <Button
                className={`text-shadow-none ${this.state.classConfirmButton}`}
                onClick={this.functionConfirm}
                disabled={this.state.isConfirmLoading || this.state.isContentLoading}
              >
                {this.state.isConfirmLoading ? (
                  <i className="fa fa-spinner fa-pulse" />
                ) : (
                  this.state.textConfirmButton
                )}
              </Button>
            </Modal.Footer>
          </Modal>
          {this.state.showIcon && (
            <i
              className="fa fa-pencil-square-o cursor-pointer text-info"
              onClick={this.open}
              disabled={this.state.disabled}
            />
          )}
          {this.state.showButton && (
            <Button
              className={`text-shadow-none ${this.state.classButton}`}
              onClick={this.open}
              disabled={this.state.disabled}
            >
              {this.state.textButton}
            </Button>
          )}
        </span>
      );
    }
  },
);

export default withRouter(ConfirmModal);



// WEBPACK FOOTER //
// ./src/components/ConfirmModal.js